/**
 * This is a polyfill library that enables IE 11 to run modern websites
 * Do not use Babel as it conflicts with Google Maps API library
 */
import "core-js/stable";
import "regenerator-runtime/runtime";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('magnific-popup');
require('./scripts/common');

window.Vue = require('vue');
import store from './store';
import Slick from 'vue-slick'

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.component('app-header', require('./components/Header.vue'));
Vue.component('app-footer', require('./components/Footer.vue'));
Vue.component('app-page-title', require('./components/PageTitle.vue'));
Vue.component('app-popup-modal', require('./components/PopupModal.vue'));
Vue.component('app-toast-message', require('./components/Toast.vue'));
Vue.component('app-logout-link', require('./components/LogOutLink.vue'));

// MODULATTE CORE ADDRESS BOOK
Vue.component('address-book', require('./modulatte-core/address/Index.vue'));
Vue.component('address-book-form', require('./modulatte-core/address/Form.vue'));

// MODULATTE CORE SUBSCRIBER FORM
Vue.component('mod-subscribe-form', require('./modulatte-core/subscribers/Form.vue'));

Vue.component('form-upload', require('./components/FormUpload.vue'));

//add a global mixin
import ModHelpers from '../../mixins/ModHelpers.js';
Vue.mixin(ModHelpers);

const app = new Vue({
  el: '#app',
  components: { Slick },
  store,
  data () {
    return {
      isLoaded: false
    }
  },

  mounted () {
    setTimeout(() => {
      this.isLoaded = true
    }, 500)
  }
});



// WEBPACK FOOTER //
// ./resources/assets/frontend/js/app.js